'use strict';
var gaDenyCookieName = 'denyGa';
var denyTrackingFb = 'denyTrackingFb';
var trackingJsLogPrefix = '[ORT-TRACKINGJS] ';

window.checkGaToggled = () => {
  if (window.trackingToggledGa !== true) {
    console.debug(trackingJsLogPrefix + 'checkGaToggled() -> not toggled before, executing');

    var cbGa = document.getElementById('toggleGA');
    if (cbGa === null) {
      console.warn('checkGaToggled() -> No GA checkbox found!');
      return;
    }

    if (window.readCookie(gaDenyCookieName) === 'true') {
      if (cbGa != null) {
        console.debug(trackingJsLogPrefix + 'checkGaToggled() cookie for GA-deny found, checking tickbox');
        cbGa.checked = true;
      }
    }
    window.trackingToggledGa = true;
    if (cbGa != null) {
      console.debug(trackingJsLogPrefix + 'checkGaToggled() adding listener for GA-Deny', cbGa);
      cbGa.addEventListener('change', toggleGaCheckbox);
    }

    toggleGoogleAnalytics();
  } else {
    console.debug(trackingJsLogPrefix + 'checkGaToggled() -> already toggled before, skipping');
  }
};

window.checkFbToggled = () => {
  if (window.trackingToggledFb !== true) {
    console.debug(trackingJsLogPrefix + 'checkFbToggled() -> not toggled before, executing');

    var cbFb = document.getElementById('toggleFbPixel');
    if (cbFb === null) {
      console.warn('checkFbToggled() -> No FB checkbox found!');
      return;
    }

    if (window.readCookie(denyTrackingFb) === 'true') {
      if (cbFb != null) {
        console.debug(trackingJsLogPrefix + 'checkFbToggled() cookie for FB-deny found, checking tickbox');
        cbFb.checked = true;
      }
    }
    window.trackingToggledFb = true;
    if (cbFb != null) {
      console.debug(trackingJsLogPrefix + 'checkFbToggled() adding listener for FB-Deny', cbFb);
      cbFb.addEventListener('click', toggleFbPixel);
    }
  } else {
    console.debug(trackingJsLogPrefix + 'checkFbToggled() -> already toggled before, skipping');
  }
};

window.createCookie = (name, value, days) => {
  console.debug(trackingJsLogPrefix + 'Creating cookie', name, value, days);
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }

  var domain = '';
  if (document.location.host == 'www.orthomol.com') {
    domain = '; domain=orthomol.com';
  }
  document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/' + domain;
};

window.readCookie = (name) => {
  var nameEq = encodeURIComponent(name) + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEq) === 0) return decodeURIComponent(c.substring(nameEq.length, c.length));
  }
  return null;
};

// check each time when the Site is visited if google is allowed to track the user
document.addEventListener('DOMContentLoaded', window.checkGaToggled, false);
window.addEventListener('load', window.checkGaToggled, false);

toggleGoogleAnalytics();

function toggleFbPixel() {
  var cbFb = document.getElementById('toggleFbPixel');
  if (cbFb === null) {
    console.error(trackingJsLogPrefix + 'toggleFbPixel -> FB checkbox not found');
    return;
  }

  if (cbFb.checked === true) {
    console.info(trackingJsLogPrefix + 'toggleFbPixel -> checkbox ticked, creating FB-Deny cookie', cbFb);
    window.createCookie(denyTrackingFb, true, 365);
  } else {
    console.info(trackingJsLogPrefix + 'toggleFbPixel -> checkbox not ticked, removing FB-Deny cookie', cbFb);
    eraseCookie(denyTrackingFb);
  }
}

function toggleGaCheckbox() {
  var gaCheckBox = document.getElementById('toggleGA');
  if (gaCheckBox === null) {
    console.error(trackingJsLogPrefix + 'toggleGaCheckbox -> GA checkbox not found');
    return;
  }
  if (gaCheckBox.checked === true) {
    console.info(trackingJsLogPrefix + 'toggleGaCheckbox -> checkbox ticked, creating GA-Deny cookie', gaCheckBox);
    window.createCookie(gaDenyCookieName, 'true', 365);
  } else {
    console.info(trackingJsLogPrefix + 'toggleGaCheckbox -> checkbox not ticked, removing GA-Deny cookie', gaCheckBox);
    eraseCookie(gaDenyCookieName);
  }

  if (window.readCookie(gaDenyCookieName) === 'true') {
    console.info(trackingJsLogPrefix + 'toggleGaCheckbox -> found GA-deny cookie, ticking box', gaCheckBox);
    gaCheckBox.checked = true;
  }

  toggleGoogleAnalytics();
}

function toggleGoogleAnalytics() {
  if (window.readCookie(gaDenyCookieName) === 'true') {
    console.debug(trackingJsLogPrefix + 'toggleGoogleAnalytics found GA-Deny cookie, setting ga-disable variable');
    window['ga-disable-UA-3263506-7'] = true;
  }
}

function eraseCookie(name) {
  console.debug(trackingJsLogPrefix + 'Erasing cookie', name);
  window.createCookie(name, '', -1);
}

(function () {
  window.addEventListener(
    'CookiebotOnDecline',
    () => {
      // gets set in AppBundle/Resource/views/salesforce/orthomol-news-result.html.twig
      eraseCookie('SfmcId');
    },
    false
  );
})();
